import { useState, useEffect } from 'react';
import { getDatabase, ref, onValue, off, query, orderByChild, equalTo } from 'firebase/database';
import app from '../../services/firebase'; // Path to your Firebase initialization
import { useNavigate } from 'react-router-dom';
import { getAuth } from 'firebase/auth';
import { Typography, Box, Button } from '@mui/material';
import '../../styles/mobidawg-style.scss'

function ContactRegistryList() {
    // const [debugMode, setDebugMode] = useState(false); // Toggle debug mode
    const [debugMode] = useState(import.meta.env.VITE_DEBUG_MODE === 'true');
    const auth = getAuth(app);
    const navigate = useNavigate();
    const database = getDatabase(app);
    const [contactRegistryState, setContactRegistryState] = useState([]);
    const [loading, setLoading] = useState(true);  // Loading state
    const [error, setError] = useState(null);      // Error state


    useEffect(() => {
        const fetchData = async () => { // Use async/await for cleaner code

            try {
                const user = auth.currentUser;
                if (!user) {
                    setError("User not logged in"); // Or redirect to login
                    setLoading(false); // Set loading to false to render something to the user.
                    return;
                }

                // Create a query to filter by the current user's UID
                const contactRegistryRef = ref(database, 'contactRegistry');
                const queryRef = query(contactRegistryRef, orderByChild('uid'), equalTo(user.uid));

                const unsubscribe = onValue(queryRef, (snapshot) => {
                    const data = snapshot.val();
                    if (data) {
                        const contactRegistry = Object.values(data); // Convert to array
                        setContactRegistryState(contactRegistry);
                        console.debug(contactRegistry)
                    } else {
                        setContactRegistryState([]); // Set to empty array if no data
                    }
                    setLoading(false); // Data fetched, set loading to false

                }, (err) => {  // Error callback for onValue
                    setError(err.message);
                    setLoading(false); // Set loading to false since error
                    console.error("Error fetching data:", err);
                });

                return () => { // added cleanup of listener when unmounting component
                    off(queryRef, 'value', unsubscribe)
                    console.log("Unmounting")
                }

            } catch (err) {
                console.log("Error:", err)
                setError("Failed to retrieve contacts");  // General error message
                setLoading(false);
            }
        };


        fetchData(); // Call the async function inside useEffect

    }, []); // Empty dependency array - runs once on mount

    return(
        <div>
            <Typography variant="h6" gutterBottom>
                Project Registry List
            </Typography>

            {/* // ... your JSX ... */}
            {/* Error or Loading State */}
            {loading ? (
                <p>Loading Project Registry...</p>
            ) : error ? (
                <p style={{ color: 'red' }}>Error: {error}</p>
            ) : (
                // This component is no longer responsible for rendering the list. It will be used for the ContactForm page.
                <Typography variant="caption">
                    <Box sx={{ textAlign: 'center', mt: 4 }}>
                        <Typography variant="body1" sx={{ mb: 2 }}>
                            No listed projects were found.
                        </Typography>
                        <Typography variant="h6" sx={{ color: 'darkblue', mb: 2, fontSize: '1.1rem' }}>
                            You can request help for your project by contacting me.
                        </Typography>
                        <Button
                            variant="contained"
                            onClick={() => navigate('/contactform')}
                        >
                            Contact Me
                        </Button>
                    </Box>
                </Typography>
            )}
                {/* Debug Info */}

        </div>
        );
}

export default ContactRegistryList;
